import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginModalService {
  private readonly shouldOpenSubject = new BehaviorSubject<boolean>(false);
  public shouldOpen$: Observable<boolean> = this.shouldOpenSubject.asObservable();

  /**
   * Trigger the login modal to open
   */
  open(): void {
    this.shouldOpenSubject.next(true);
  }

  /**
   * Reset the trigger (called after modal is opened)
   */
  reset(): void {
    this.shouldOpenSubject.next(false);
  }

  /**
   * Get current state
   */
  get shouldOpen(): boolean {
    return this.shouldOpenSubject.value;
  }
}

